








import { defineComponent } from '@vue/composition-api';

const CreateDeliveryNoteStats = defineComponent({
  props: {
    value: { default: () => (0) },
  },
});

export default CreateDeliveryNoteStats;
